<template>
    <div>
        <div class="header mt-5 mb-5">
            {{ $vuetify.lang.t('$vuetify.activityLog.header')}}
        </div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.activityLog.searchText')"
                        solo
                        height="40px"
                        @keyup.enter="searchActivityLog()">
                    </v-text-field>
                    <v-btn
                        class="ml-3"
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchActivityLog()">
                        {{ $vuetify.lang.t('$vuetify.activityLog.search') }}
                    </v-btn>
                </div>
                <div class="filter-input">
                    <date-picker-range
                        v-model="dateRange" />
                </div>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalActivityLog"
                :items="activityLogs"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <div :class="actionStyle(item)">
                            <i class="mr-4 far fa-download" @click="goToDownload(item)"></i>
                        </div>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div
            v-if="pageCount"
            class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import DatePickerRange from '@/components/DatePickerRange.vue'

export default {
    name: 'ActivityLog',

    components: {
        DatePickerRange
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalActivityLog: 0,
            activityLogs: [],
            dateRange: [this.$dateUtil.getCurrentDate(), this.$dateUtil.getCurrentDate()]
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.activityLog.dateTime'), value: 'date_time', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.activityLog.employeeId'), value: 'employee_id', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.activityLog.userName'), value: 'username', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.activityLog.change'), value: 'change', width: '15%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.activityLog.menu'), value: 'menu', width: '20%', sortable: false },
                { text: this.$vuetify.lang.t('$vuetify.activityLog.action'), value: 'action', align: 'center', width: '5%', sortable: false }
            ]
        }
    },

    methods: {
        async searchActivityLog () {
            this.options.page = 1
            await this.getActivityLogs()
        },

        async getActivityLogs () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `activity-logs?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.dateRange.length > 0) {
                url += `&dateRange=${JSON.stringify(this.dateRange)}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.activityLogs = res.data.data
                this.totalActivityLog = res.data.total
            }
            this.loading = false
        },

        goToDownload (item) {
            const data = JSON.stringify(item.log_data)
            const dateStr = this.$dateUtil.formatSerialDateTime(new Date())
            const empId = item.employee_id || 'system'
            this.$utils.saveLocalFile(`${dateStr}_${empId}.txt`, data)
        },

        actionStyle (item) {
            return item.method === 'LIN' || item.method === 'OUT' ? 'action-disable' : 'action-enable'
        }
    },

    watch: {
        options: {
            async handler () {
                await this.getActivityLogs()
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getActivityLogs()
            },
            deep: true
        },
        dateRange () {
            if (this.dateRange.length === 0 || this.dateRange.length === 2) {
                this.getActivityLogs()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .action-header .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 340px;
    }

    ::v-deep .search-input .v-input__control > .v-input__slot {
        width: 340px;
    }

    ::v-deep .date-range-input .v-input__control > .v-input__slot {
        width: 220px;
    }

    ::v-deep .v-input__prepend-inner {
        margin: auto !important;
    }

    .action {
        display: flex;
        align-items: center;

        .action-enable i {
            cursor: pointer;
            color: #6c6c6c !important;
            font-weight: 500 !important;
            font-size: 16px;
        }

        .action-disable i {
            pointer-events: none;
            cursor: not-allowed;
            color: #a8a8a8 !important;
            font-weight: 300 !important;
            font-size: 16px;
        }
    }
</style>
